import { DelayedRequestsStore } from './delayed-requests.store';
import { Component, computed, inject } from '@angular/core';
import { BaseDialogService } from '../../kit/base-dialog/base-dialog-service';
import { SplitButton } from '@openng/optimus-ui/splitbutton';
import { OfflineDb } from '../../../store/offline-db/offline.db';
import { MenuItem } from '@openng/optimus-ui/api';
import { translate } from '../../../modules/shared/shared.global-service';
import { isOffline } from '../../../utils/connection.service';
import {
    DelayedRequestsPreviewDialogComponent,
} from './delayed-requests-preview-dialog/delayed-requests-preview-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';
import { continueDelayedWork } from './delayed-requests.util';
import { successDeleted } from '../../../modules/content/content.error';

@Component({
    selector: 'app-delayed-requests',
    templateUrl: './delayed-requests.component.html',
    styleUrl: './delayed-requests.component.scss',
    providers: [DelayedRequestsStore],
    imports: [
        SplitButton,
        TranslatePipe,
    ],
})
export class DelayedRequestsComponent {

    protected readonly store = inject(DelayedRequestsStore);
    protected readonly dialogService = inject(BaseDialogService);
    protected readonly offlineDb = inject(OfflineDb);

    protected commands = computed<MenuItem[]>(() => {
        return [
            <MenuItem>{
                icon: 'pi pi-pencil',
                label: translate.instant('common.continue'),
                command: () => this.continueFirst(),
            },
            <MenuItem>{
                icon: 'pi pi-info-circle',
                label: translate.instant('common.preview'),
                command: () => this.preview(),
            },
            <MenuItem>{
                icon: 'pi pi-trash',
                label: translate.instant('common.deleteAll'),
                command: async () => {
                    await this.offlineDb.delayedDb.clear();
                    successDeleted();
                },
            },
        ];
    });

    protected preview(): void {
        this.dialogService.open(
            DelayedRequestsPreviewDialogComponent,
            {
                header: translate.instant('common.preview'),
            },
        );
    }

    protected async continueFirst(): Promise<void> {
        const item = await this.offlineDb.delayedDb.first();
        if (!item) return;
        await continueDelayedWork(item);
    }

    protected readonly isOffline = isOffline;
}
